import { render } from "./GuideEditor.vue?vue&type=template&id=dea3bd98&scoped=true"
import script from "./GuideEditor.vue?vue&type=script&lang=js"
export * from "./GuideEditor.vue?vue&type=script&lang=js"

import "./GuideEditor.vue?vue&type=style&index=0&id=dea3bd98&scoped=true&lang=css"
import "./GuideEditor.vue?vue&type=style&index=1&id=dea3bd98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea3bd98"]])

export default __exports__